/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference } from 'services'
import { collectionNames } from 'constant'

export const getLastUpdatedSchedulerList = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      const schedulerConfigRef: any = getCollectionReference(
        collectionNames.SCHEDULER_CONFIG,
      ).orderBy('updated_at', 'desc')
      schedulerConfigRef
        .get()
        .then((queryRef: any) => {
          let i = 0
          queryRef.docs.map((doc: any) => {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLastUpdatedSchedulerList | error', error)
      reject(error)
    }
  })
}
